import React from 'react'
import MaterialSymbol from '../material-symbol'

const Bolt = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="bolt" {...props} />
))

Bolt.displayName = 'Bolt'

export default Bolt
